import React, { Component } from 'react';
import { withRouter } from '../../WithRouterHOC';
import { Avatar, Modal, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import HTTP from '../../../script/service';
import Util from '../../../script/util';
import { _show_coupon_modal } from '../../../store/Action';
import './recRecommend.scss';
import { DDLoading } from '../../globalPageStatus';

class recRecommend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false, // 是否展示弹窗
      loading: true, // 是否在加载中
      recList: [], // 推荐人列表
      checkList: [], // 关注列表
    };
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  // 获取推荐人列表
  getGodStar = () => {
    const { base } = this.props;
    const params = { uid: base.uid };
    this.setState({ loading: true });
    HTTP._get_god_star(params)
      .then((res) => {
        if (res && res.code === 200) {
          const { data } = res;

          const checkList = data.map((item) => item.uid);

          this.setState({
            recList: data,
            checkList,
          });
        } else {
          this.setState({
            recList: [],
          });
        }
        this.setState({ loading: false });
      })
      .catch((err) => {
        this.setState({
          recList: [],
          loading: false,
        });
      });
  };

  // 是否展示推荐弹窗
  openCloseModal = (bool = false) => {
    this.setState({ visible: bool });

    if (bool) {
      this.getGodStar();
    } else {
      const { stepInfo } = this.props.base;

      // 展示新手礼包弹窗
      if (stepInfo && stepInfo.isNew) {
        _show_coupon_modal();
      }
    }
  };
  // 点击每个推荐人加关注，取消关注
  changeCheckItem = (item) => {
    const { checkList } = this.state;
    const isCheck = checkList.findIndex((_item) => _item === item.uid);
    const arr = checkList;
    if (isCheck !== -1) {
      arr.splice(isCheck, 1);
    } else {
      arr.push(item.uid);
    }
    this.setState({ checkList: arr });
  };

  // 一键关注所有
  handleSubmit = () => {
    const { base } = this.props;
    const { recList, checkList } = this.state;
    this.setState({ loading: true }, () => {
      const followed = recList.filter((item) => item.focusStatus === 1);
      const unFollowed = recList.filter((item) => item.focusStatus === 0);
      let focus = unFollowed.filter(
        (item) => checkList.indexOf(item.uid) !== -1
      ); // 新增关注 // 交集
      let cancel = followed.filter(
        (item) => checkList.indexOf(item.uid) === -1
      ); // 新增取消关注 // 差集
      focus = focus.map((item) => item.uid);
      cancel = cancel.map((item) => item.uid);

      const params = {
        uid: base.uid,
        otherUid: focus.join(','),
        unFocusOtherUid: cancel.join(','),
      };

      HTTP._get_all_focus_user(params)
        .then((res) => {
          if (res && res.code === 200) {
            // 关注成功
            this.setState({ visible: false });

            // 展示新手礼包弹窗
            if (base.stepInfo && base.stepInfo.isNew) {
              _show_coupon_modal();
            }
          } else {
            message.error((res && res.message) || '关注失败请稍候重试');
          }
        })
        .catch((err) => {
          message.error('关注失败请稍候重试');
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    });
  };

  // 刷新大神
  handleRefresh = () => {
    this.getGodStar();
  };

  render() {
    const { visible, loading, recList, checkList } = this.state;
    return (
      <Modal
        open={visible}
        wrapClassName="daidai-modal-style perfect-wrapper"
        footer={
          <button className="daidai-btn-primary" onClick={this.handleSubmit}>
            一键关注并Say HI {loading ? <LoadingOutlined /> : null}
          </button>
        }
        centered
        width={770}
        height={500}
        maskClosable={false}
        onCancel={() => this.openCloseModal()}
      >
        <div className="recommend-wrapper">
          <div className="step-header">
            <h2 className="step-title">告诉我的专属大神，我来了！</h2>
          </div>
          <DDLoading status={loading}>
            <div className="recommend-box">
              {recList &&
                recList.map((item, index) => (
                  <div
                    key={index}
                    className={[
                      'rec-item',
                      checkList.indexOf(item.uid) !== -1 ? 'active' : '',
                    ].join(' ')}
                    onClick={() => this.changeCheckItem(item)}
                  >
                    <i className="game-icon">{/*爱心图标*/}</i>
                    <Avatar
                      size={60}
                      src={Util.transImgUrl(item.avatar, '60x60')}
                    />
                    <p className="rec-name">{item.nickname}</p>
                    <div className="user-desc">
                      {/*{!!item.soundType ? <p className="tag-source">{item.soundType}</p> : null}*/}
                      <p
                        className={`rec-sex${item.sex === 1 ? ' female' : ' male'}`}
                      >
                        <span className="icon">
                          {item.sex === 1 ? (
                            <i className="female" />
                          ) : (
                            <i className="male" />
                          )}
                        </span>
                        <span>{item.age || 18}</span>
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </DDLoading>
          <div>
            <span className="refresh-text" onClick={this.handleRefresh}>
              <i className="icon-refresh" /> 换一批
            </span>
          </div>
        </div>
      </Modal>
    );
  }
}

export default withRouter(recRecommend, { withRef: true });
